/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-12-06 12:00:28
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-07 15:27:57
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardSpeedyEntry\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { Component } from "react";

import { BsyUtils } from "../../../utils/Utils";
import "./index.css";

export default class BsyDashboardSpeedyEntry extends Component {
  static defaultProps = {
    entrys: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      entrys: props.entrys,
    };
  }
  componentDidMount() {
    this.props?.onRefreshChars?.();
  }
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const entrys = { ...nextProps.entrys };
    this.setState({
      entrys: entrys,
    });
  }
  setIcon = (data) => {
    if (data.customIconSwitch && data.style.newIcon) {
      return data.style.newIcon;
    } else if (data.customUrl) {
      return data.style.newIcon || data.style.icon;
    } else {
      return data.style.icon;
    }
  };
  render() {
    const { entrys } = this.state;
    const boxWidth =
      this.props.mode === "edit"
        ? document.querySelector("#bby").clientWidth - 320
        : document.querySelector("#bby").clientWidth - 70;
    const totalMargin = boxWidth % 180;
    const numMargin = totalMargin / parseInt(boxWidth / 180) / 2;
    let ars = [];
    if (entrys.entries) {
      if (Array.isArray(entrys.entries)) {
        ars = entrys.entries;
      } else {
        for (let key in entrys.entries) {
          ars.push(entrys.entries[key]);
        }
      }
    }
    return (
      <div className={"dashboard-speedy-entry " + this.props.mode}>
        <div className="speedy-entry-box">
          {ars.length > 0 ? (
            ars.map((data, index) => {
              if (!data) {
                return "";
              }
              let url = data.customUrl
                ? data.customUrl
                : data.type === "app"
                  ? window.rootDirectroy + "/team/app/" + data._id
                  : window.rootDirectroy +
                  "/team/app/" +
                  data.appId +
                  "/" +
                  data.type +
                  "/" +
                  data.entryId;
              return (
                <a
                  target={data.openMode === "newPage" ? "_blank" : ""}
                  className={`entry-item ${entrys.layoutStyle}`}
                  style={{ margin: `7px 5px` }}
                  href={url} // `7px ${numMargin}px`
                  //onClick={e => { this.pupumPane(data) }}
                  key={"speedy-entry-box-" + index}
                  rel="noreferrer"
                >
                  <div className="item-cont">
                    {(data.iconType === "form" || data.iconType === "report" || data.iconType === "dash" || data.iconType === "scenes" || !data.customIconSwitch) && !data.customUrl && data.type !== "app" && (
                      <>
                        <i className={"entry-icon 1 " + BsyUtils.getFormIcon(data)}
                        />
                        <span className={"entry-title"}>
                          {data.customName || data.name || data.appname}
                        </span>
                      </>
                    )}
                    {(data.iconType === "app" || data.iconType === "url") && data.customIconSwitch && (
                      <>
                        <div
                          className={
                            "app-icon 2 color-cover-" + data.style.color
                          }
                        >
                          <div
                            className={
                              "imgbg-bsy-app imgbg-bsy-app-" +
                              this.setIcon(data)
                            }
                          />
                        </div>
                        <span className="app-name">
                          {data.customName || data.appname || data.name}
                        </span>
                      </>
                    )}
                    {((data.iconType === "system" && data.customIconSwitch) || data.customUrl) && data.iconType !== "image" && (
                      <>
                        <div
                          className={
                            "app-icon 3 color-cover-" + data.style.color
                          }
                        >
                          <div
                            className={
                              "imgbg-bsy-app imgbg-bsy-app-" +
                              this.setIcon(data)
                            }
                          />
                        </div>
                        <span className="app-name">
                          {data.customName || data.appname || data.name}
                        </span>
                      </>
                    )}
                    {data.type === "app" && !data.customIconSwitch && data.parent === "default" && (
                      <>
                        <div
                          className={
                            "app-icon 4 color-cover-" + data.style.color
                          }
                        >
                          <div
                            className={
                              "imgbg-bsy-app imgbg-bsy-app-" + data.style.icon
                            }
                          />
                        </div>
                        <span className="app-name">
                          {data.customName || data.appname || data.name}
                        </span>
                      </>)}
                    {data.type === "app" && !data.customIconSwitch && data.parent !== "default" && (
                      <>
                        <div
                          className={
                            "app-icon 3 color-cover-" + data.style.color
                          }
                        >
                          <div
                            className={
                              "imgbg-bsy-app imgbg-bsy-app-" +
                              this.setIcon(data)
                            }
                          />
                        </div>
                        <span className={"entry-title"}>
                          {data.customName || data.name || data.appname}
                        </span>
                      </>
                    )}
                    {data.iconType === "image" && (
                      <>
                        <div
                          className={`img-bg`}
                          style={{
                            backgroundImage: `url(${data.imageUrl})`,
                            backgroundSize: "100%",
                          }}
                        ></div>
                        <span className="app-name">
                          {data.customName || data.appname || data.name}
                        </span>
                      </>
                    )}
                  </div>
                </a>
              );
            })
          ) : (
            <>
              <div className="bsy-componen-empty-box">
                <div className="empty-box-text">暂未设置快捷入口</div>
                {this.props.mode === "edit" ? (
                  <div
                    className="empty-box-btn"
                    onMouseDown={(event) => {
                      this.props?.onSetEntry(event);
                    }}
                  >
                    {React.language("setting")}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
